import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "iconPath"
})
export class IconPathPipe implements PipeTransform {
  transform(type: string): string {
    switch (type) {
      case "error":
        return "./icons/red-icon.png";
      case "success":
        return "./icons/green-icon.png";
      case "info":
        return "./icons/blue-icon.png";
      default:
        return "./icons/blue-icon.png";
    }
  }
}